var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ixl",attrs:{"id":"app"}},[(_vm.generalMsg.text != '')?_c('div',{staticClass:"top-banner",style:("background-color:" +
      _vm.generalMsg.background_color +
      "; color:" +
      _vm.generalMsg.text_color +
      ";")},[_c('span',{staticClass:"texttop",domProps:{"innerHTML":_vm._s(_vm.generalMsg.text)}})]):_vm._e(),_c('Header'),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }